/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_BrainInputs */

const es_common_brain = /** @type {(inputs: Common_BrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Razonamiento`)
};

const en_common_brain = /** @type {(inputs: Common_BrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Reasoning`)
};

/**
* | output |
* | --- |
* | "Extra Reasoning" |
*
* @param {Common_BrainInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_brain = /** @type {((inputs?: Common_BrainInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_BrainInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_brain(inputs)
	return en_common_brain(inputs)
});
export { common_brain as "common.brain" }